export class ImageUrlProvider {
    public static translate(url: string, width: number, height: number, scalingAlgorithm: ScalingAlgorithm = "cropped") {
        return url
            .replace("/raw/", `/${scalingAlgorithm}/${width}/${height}/`)
            .replace("/240/240/", `/${width}/${height}/`)
            .replace("240%2f240", `${width}%2f${height}`)
    }
}

export type ScalingAlgorithm = "cropped";